import { render, staticRenderFns } from "./differentialPricing.vue?vue&type=template&id=0c5da1eb&scoped=true"
import script from "./differentialPricing.vue?vue&type=script&lang=ts"
export * from "./differentialPricing.vue?vue&type=script&lang=ts"
import style0 from "./differentialPricing.vue?vue&type=style&index=0&id=0c5da1eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5da1eb",
  null
  
)

export default component.exports